import React from "react";
import { cn } from "../../ui/utils/cn";
import type { ContributionStatus } from "../../services/rtkApi/contributeApi";

// shared status presentation for the member-facing contribute surfaces. Keeps the
// chip wording friendly (no internal jargon) and on-brand (brutal border + tints).
export const STATUS_META: Record<string, { label: string; cls: string }> = {
  draft: { label: "draft", cls: "bg-gray-100 text-gray-600" },
  submitted: { label: "submitted", cls: "bg-sky/40 text-ink" },
  triaged: { label: "reviewing", cls: "bg-lemon/50 text-ink" },
  accepted: { label: "accepted", cls: "bg-mint/50 text-ink" },
  building: { label: "building", cls: "bg-gold/50 text-ink" },
  shipped: { label: "shipped ✨", cls: "bg-mint text-ink" },
  declined: { label: "archived", cls: "bg-pink/30 text-ink" },
};

export function StatusChip({ status }: { status: ContributionStatus | string }) {
  const m = STATUS_META[status] || STATUS_META.submitted;
  return (
    <span
      className={cn(
        "inline-block text-[11px] font-bold uppercase tracking-wide px-2 py-0.5 border-2 border-ink rounded-sm",
        m.cls
      )}
    >
      {m.label}
    </span>
  );
}
